/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { KTSVG } from "_metronic/helpers";
import { useEffect, useState } from "react";
import { Sidebar, sidebarClasses } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons";
import { AsideMenuItems } from "./AsideMenuItems";
import { useMediaLayout } from "cpl-react-common/Hooks/useMediaQuery";
import { MediaBreakpoints } from "cpl-react-common/components/Enums/MediaBreakpoints";
import SimpleModal from "cpl-react-common/components/Modals/SimpleModal";
import useAsideMenu from "hooks/useAsideMenu";
import CookiePreferencesModal from "app/system/cookies/CookiePreferencesModal";
import { useSelector } from "react-redux";
import { selectGlobalSettings } from "app/modules/system/settings/ClientPortalSettingsSlice";

const AsideMenu = () => {
  const { isMobile, isTablet, isDesktop } = useMediaLayout();
  const [showModal, setShowModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const { asideToggled, setAsideMenuToggled, asideCollapsed, setAsideMenuCollapsed } = useAsideMenu();
  const getInTouchLink = useSelector(selectGlobalSettings).getInTouchLink;
  const { pathname } = useLocation();

  // Close the aside on navigation so it doesn't sit over the page content on mobile/tablet.
  useEffect(() => {
    if (isDesktop) return;
    setAsideMenuToggled(!isMobile);
    setAsideMenuCollapsed(isTablet);
  }, [pathname]);

  return (
    <>
      <Sidebar
        collapsed={asideCollapsed}
        onBackdropClick={() => {
          setAsideMenuToggled(!isMobile);
          setAsideMenuCollapsed(!isMobile);
        }}
        toggled={asideToggled}
        className={`aside ${asideToggled ? "" : "w-0"} ${isTablet ? "broken" : ""}`}
        collapsedWidth="50px"
        rootStyles={{
          border: 0,
          [`.${sidebarClasses.container}`]: {
            backgroundColor: "var(--cpl-navbar-bg-colour)",
            display: "flex",
            flexDirection: "column",
            boxShadow: !isDesktop && asideToggled && !asideCollapsed ? "5px 0px 30px #222" : "none",
          },
        }}
        customBreakPoint={`${MediaBreakpoints.SM}px`}
        id="aside"
      >
        {!asideCollapsed && asideToggled && (
          <div className="d-flex justify-content-end d-xl-none pt-4 px-4">
            <FontAwesomeIcon
              icon={faClose as IconProp}
              fontSize={16}
              color="var(--cpl-navbar-text-colour)"
              className="cursor-pointer"
              data-test-id="sidebar__close-button"
              onClick={() => {
                setAsideMenuToggled(!isMobile);
                setAsideMenuCollapsed(!isMobile);
              }}
            />
          </div>
        )}
        <AsideMenuExpander />
        {!asideCollapsed && asideToggled && (
          <div className="aside-logo m-6" id="kt_aside_logo">
            <Link to="/" data-test-id="sidebar__logo-link">
              <img alt="CPL Brand Logo" className="logo-default cpl-brand-logo d-inline-block mw-100" />
            </Link>
          </div>
        )}
        <AsideMenuItems />
        {!asideCollapsed && asideToggled && (
          <div className="mt-auto aside-text d-flex justify-content-center align-items-center mb-4">
            <span className="aside-text me-2">{new Date().getFullYear()} &copy; CPL Software Ltd.</span>
            <span className="btn p-0 m-0" onClick={() => setShowInfoModal(true)} data-test-id="sidebar__info-button">
              <FontAwesomeIcon icon={faCircleInfo as IconProp} className="aside-text" />
            </span>
          </div>
        )}
      </Sidebar>
      <SimpleModal
        modalTitle=""
        showModal={showInfoModal}
        dismissModalCallback={() => setShowInfoModal(false)}
        hideDividers
        centered
      >
        <div>
          <div className="d-flex justify-content-center">
            <img
              alt="Logo"
              className="logo-default cpl-brand-logo h-125px"
              style={{ backgroundColor: "white", padding: 8 }}
            />
          </div>
          <div className="fw-semibold d-flex justify-content-around px-8 mt-12">
            <a
              type="button"
              className="cpl-text-primary text-decoration-none"
              onClick={() => setShowModal(true)}
              data-test-id="sidebar-info-modal__cookie-policy-button"
            >
              Cookie Policy
            </a>
            <CookiePreferencesModal showModal={showModal} setShowModal={setShowModal} />
            <a
              type="button"
              className="cpl-text-primary text-decoration-none"
              href="/accessibility"
              target="_blank"
              data-test-id="sidebar-info-modal__accessibility-statement-link"
            >
              Accessibility Statement
            </a>
            {getInTouchLink && (
              <a
                className="cpl-text-primary text-decoration-none"
                href={getInTouchLink}
                target="_blank"
                data-test-id="sidebar-info-modal__get-in-touch-link"
              >
                Get In Touch
              </a>
            )}
          </div>
          <div className="fw-muted d-flex justify-content-center mt-4">
            {new Date().getFullYear()} &copy;{" "}
            <a
              className="cpl-text-primary text-decoration-none"
              href="https://cplsoftware.com"
              target="_blank"
              data-test-id="sidebar-info-modal__cpl-software-link"
            >
              CPL Software Ltd
            </a>
            . All rights reserved.
          </div>
        </div>
      </SimpleModal>
      {isTablet && <div className="h-100" style={{ width: "50px" }}></div>}
    </>
  );
};

export const AsideMenuExpander = () => {
  const { asideCollapsed, setAsideMenuCollapsed } = useAsideMenu();
  return (
    <div
      className={`aside d-flex justify-content-center align-items-center z-3 ${asideCollapsed ? "" : "d-none"}`}
      style={{ width: "50px", height: "50px" }}
    >
      <div className="d-flex align-items-center me-1" title="Show aside menu">
        <div
          className="btn btn-icon w-30px h-30px w-md-40px h-md-40px"
          onClick={() => setAsideMenuCollapsed(!asideCollapsed)}
          data-test-id="sidebar__expand-button"
        >
          <KTSVG
            path="/media/icons/duotune/abstract/abs015.svg"
            className="svg-icon-2x mt-1"
            color="var(--cpl-navbar-text-colour)"
          />
        </div>
      </div>
    </div>
  );
};

export { AsideMenu };
